<!--
	ChatToggle: the SafeCurves assistant button. A bottom-left map control
	(mounted via `map.extraControls`); `--chat-push` slides it in with the panel.
-->
<script lang="ts">
	import { apiKeyStore } from '#lib/stores/apiKeyStore.svelte.js';
	import { dataChatStore } from './dataChatStore.svelte';
	import ChatBubble from '#lib/assets/chat-bubble-left-right.svg?raw';

	$effect(() => {
		if (!dataChatStore.enabled) return;
		const apiKey = apiKeyStore.apiKey;
		if (apiKey) void dataChatStore.ensureAvailable(apiKey);
	});
</script>

{#if dataChatStore.enabled && dataChatStore.isAvailable}
	<div
		class="chatToggle maplibregl-ctrl maplibregl-ctrl-group"
		class:active={dataChatStore.isOpen}
		class:working={dataChatStore.isLoading}>
		<button
			type="button"
			title="SafeCurves assistant"
			aria-label={dataChatStore.isOpen ? 'Hide SafeCurves assistant' : 'Open SafeCurves assistant'}
			aria-expanded={dataChatStore.isOpen}
			onclick={() => dataChatStore.toggle()}>
			{@html ChatBubble}
		</button>
	</div>
{/if}

<style>
	.chatToggle {
		/* Bottom-left, one control-width right of the active-legend button; --chat-push slides it in (0 below 700px). */
		position: absolute;
		bottom: var(--legend-bottom);
		left: calc(
			var(--ctrl-spacing-sides) + var(--chat-push, 0px) + var(--ctrl-button-size) + var(--space-4)
		);
		z-index: var(--z-panel);
		border-radius: var(--radius);
		transition: left 0.2s ease-out;

		/* Extra class to beat MapLibre's later-loading `:not(:empty)` shadow at equal specificity. */
		&.maplibregl-ctrl-group:not(:empty) {
			box-shadow: var(--ctrl-shadow);
		}

		/* Mounts outside `.maplibregl-map`, so app.css's ctrl-group button rules don't reach it. */
		button {
			display: flex;
			justify-content: center;
			align-items: center;
			width: var(--ctrl-button-size);
			height: var(--ctrl-button-size);
			color: var(--ctrl-text);

			/* `:global`: the `{@html}` icon escapes Svelte scoping. */
			& > :global(svg) {
				width: var(--ctrl-icon-size);
				height: var(--ctrl-icon-size);
			}
		}
	}
</style>
